import { useCallback } from 'react';

import { LoadingSkeleton as Skeleton } from '../../atoms';
import { caraouselSizeForRoomImages } from '../../organisms/RoomImageCarousel/RoomImageCarousel.config';
import { StyledLoader } from './RateCard.styles';

import { useScreenViewport } from '../../utils';

export const RateCardLoader = () => {
  const viewport = useScreenViewport();

  const RateContainer = () => {
    return (
      <div className="skeleton-container mb-3 px-3">
        <div className="rate-name-price">
          <Skeleton height={60} />
          <Skeleton height={60} />
        </div>
        <Skeleton height={30} style={{ borderRadius: '25px' }} />
      </div>
    );
  };

  const RoomRateCardLoader = useCallback(() => {
    const caraouselSize = caraouselSizeForRoomImages?.[viewport];
    return (
      <div className="room-container mb-3">
        <Skeleton
          height={caraouselSize?.height}
          width={caraouselSize?.width}
          style={{ borderRadius: caraouselSize?.imgBorderRadius }}
        />
        <div>
          <div className="skeleton-container room-name mb-3 p-3">
            <Skeleton height={30} />
            <Skeleton height={30} />
          </div>
          {RateContainer()}
          {RateContainer()}
        </div>
      </div>
    );
  }, [viewport]);

  return (
    <StyledLoader data-component-name="o-book-RateCard-Loading" className="container">
      {RoomRateCardLoader()}
      {RoomRateCardLoader()}
    </StyledLoader>
  );
};
